const ZEP_INQUIRY_URL = 'https://zep.us/docs/inquiry';

export type InquiryService = 'core' | 'quiz';
export type InquiryLanguage = 'ko' | 'en' | 'ja';

export interface CreateInquiryUrlOptions {
  service: InquiryService;
  workflowId: string;
  nodeId: string;
  lang: InquiryLanguage;
}

/** CRM 문의 워크플로우를 여는 ZEP 임베드 URL을 생성한다. */
export const createInquiryUrl = ({
  service,
  workflowId,
  nodeId,
  lang,
}: CreateInquiryUrlOptions): string => {
  const url = new URL(ZEP_INQUIRY_URL);
  url.searchParams.set('service', service);
  url.searchParams.set('workflow_id', workflowId);
  url.searchParams.set('node_id', nodeId);
  url.searchParams.set('lang', lang);

  return url.toString();
};
